// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 10703-游泳池新增 POST /web/v1/pool/add */
export async function addPool(
  body: API.SwimPoolAddVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/pool/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10705-游泳池删除 GET /web/v1/pool/delete/${param0} */
export async function deletePool(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deletePoolParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/pool/delete/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 10702-游泳池详情查询 GET /web/v1/pool/detail/${param0} */
export async function getPoolDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPoolDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimPoolDetailVo>(
    `/web/v1/pool/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 10701-游泳池列表查询 GET /web/v1/pool/list */
export async function getPoolList(options?: { [key: string]: any }) {
  return request<API.YmResultVOListSwimPoolListVo>("/web/v1/pool/list", {
    method: "GET",
    ...(options || {}),
  });
}

/** 10704-游泳池修改 POST /web/v1/pool/update */
export async function updatePool(
  body: API.SwimPoolUpdateVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/pool/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
